import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=c22720c8&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=ts"
export * from "./Assignment.vue?vue&type=script&lang=ts"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=c22720c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22720c8",
  null
  
)

export default component.exports